import React from "react";

function CostPerLeadIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#37367D" rx="5"></rect>
            <path
                fill="#fff"
                d="M17 25.276l4.019 4.049 4.408-4.439V42.49h5.698V24.886l4.408 4.439 4.02-4.049L28.275 14 17 25.276z"
            ></path>
        </svg>
    );
}

export default CostPerLeadIcon;
